// @flow
import { useContext } from "react";
import { css, ThemeContext } from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretLeft } from "@fortawesome/free-solid-svg-icons";

export type BackButtonProps = {
  onClick?: () => void,
};

export const BackButton = ({
  children = "Back",
  prev,
}: {|
  children?: string,
  prev: () => void,
|}) => {
  const theme = useContext(ThemeContext);
  return (
    <button
      type="button"
      css={css`
        position: relative;
        text-decoration: none;
        border: none;
        cursor: pointer;
        color: ${theme.palette.hague40};
        background-color: transparent;
        outline: none;
        -webkit-tap-highlight-color: transparent;
        display: inline-flex;
        align-items: center;

        &:focus {
          text-decoration: underline;
        }
      `}
      data-test="onboarding-form:back-button"
      onClick={prev}
    >
      <FontAwesomeIcon
        color={theme.palette.terracotta100}
        css="vertical-align: middle;padding-right: 10px;"
        icon={faCaretLeft}
      />
      {children}
    </button>
  );
};
